import React from "react";

import "./Fifa.css";

const Fifa = ({ contestDetails }) => {
  var cardgrad = {
    background: `linear-gradient(141.7deg, ${contestDetails?.buttonColor} 0%, rgba(38, 38, 38, 0) 35.04%, rgba(38, 38, 38, 0) 35.04%), #171717`,
  };
  // console.log(contestDetails?.contestStatus);
  return (
    <>
      <div className="px-[16px] borderRound  z-10  pt-[20px] flex flex-col">
        <span
          className=" text-[23px] text-center font-semibold"
          style={{ color: contestDetails?.buttonColor }}
        >
          {contestDetails?.campaignName}
        </span>
        {contestDetails?.contestType !== "NC" && (
          <div className="flex w-[100%] justify-evenly items-center ">
            <div className="flex flex-col items-center ">
              <div className="w-[68px] h-[68px] rounded-full overflow-hidden border-2">
                <img src={contestDetails?.teamFlags?.teamOne} alt="" />
              </div>
              <p className="text-white mt-[10px]">{contestDetails?.teamOne}</p>
            </div>
            <p>VS</p>
            <div className="flex flex-col items-center ">
              <div className="w-[68px] h-[68px] rounded-full overflow-hidden border-2">
                <img src={contestDetails?.teamFlags?.teamTwo} alt="" />
              </div>
              <p className="text-white mt-[10px]"> {contestDetails?.teamTwo}</p>
            </div>
          </div>
        )}
        {/* <span style={{ color: contestDetails?.buttonColor }} className=" text-[17px] md:text-[20px]">
          {contestDetails?.contestName}
        </span> */}
      </div>
      {/* <div className="w-[100%] h-auto mt-[96px] ">
        <div className="relative">
          <img
            src={contestDetails?.contestPoster}
            alt=""
            className="w-[100%] "
          />
          {contestDetails?.contestType !== "NC" && (
            <div className="flex w-[100%] justify-evenly items-center absolute bottom-[-40px] blackGrad">
              <div className="flex flex-col items-center ">
                <div className="w-[68px] h-[68px] rounded-full overflow-hidden border-2">
                  <img src={contestDetails?.teamFlags?.teamOne} alt="" />
                </div>
                <p className="text-white mt-[10px]">
                  {contestDetails?.teamOne}
                </p>
              </div>
              <p>VS</p>
              <div className="flex flex-col items-center ">
                <div className="w-[68px] h-[68px] rounded-full overflow-hidden border-2">
                  <img src={contestDetails?.teamFlags?.teamTwo} alt="" />
                </div>
                <p className="text-white mt-[10px]">
                  {" "}
                  {contestDetails?.teamTwo}
                </p>
              </div>
            </div>
          )}
        </div>
        {contestDetails?.contestStatus != "CLOSED" && (
          <>
            <div className="h-auto  z-[100]">
              <div className="px-[16px]">
                <p className="four text-[14px] mt-[70px]">
                  {contestDetails?.grouping}
                </p>
                <p className="six text-[28px] mt-[10px]">
                  {contestDetails?.contestName}
                </p>
                <p className="four text-[16px] text-[#B7B7B7] mt-[15px]">
                  {contestDetails?.contestTagLine}
                </p>
                <div
                  className={`w-[100%] h-[auto] rounded-[20px] p-[16px] mt-[30px] `}
                  style={cardgrad}
                >
                  <p className="five text-[21px]">
                    {contestDetails?.entryFee?.heading}
                  </p>
                  <p className="four text-[14px] text-[#B7B7B7] mt-[15px]">
                    {contestDetails?.entryFee.fee}
                  </p>
                  <p className="four text-[14px] text-[#B7B7B7] mt-[15px]">
                    {contestDetails?.entryFee.description}
                  </p>
                  {"prizeImage" in contestDetails?.entryFee && (
                    <img src={contestDetails?.entryFee.prizeImage} alt="" />
                  )}
                </div>
                <p className="four text-[16px] text-[#B7B7B7] mt-[30px]">
                  If you want to learn more about the contest or rules of
                  participation.{" "}
                </p>
                <div className="px-[32px] py-[10px] bg-[#414141] rounded-full w-[195px] text-[14px] mt-[10px]">
                  How to participate?
                </div>
              </div>
            </div>
          </>
        )}
      </div> */}
    </>
  );
};

export default Fifa;
